import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RegisterValidation, UserRegistration, LoginValidation, UserLogin } from '../Data';
import { toast } from 'react-toastify';
import Util from '../../Classes/Utils';
import Cookies from "js-cookie";


const Authentication = (props) => {

	const [phonenumber, setPhonenumber] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");

	const navigate = useNavigate();

	const handleRegister = (e) => {
		e.preventDefault();
		if (RegisterValidation(email, password, firstName, lastName, confirmPassword)) {
			UserRegistration(email, password, firstName, lastName).then((result) => {
				toast.success("Customer Successfully registered");
				localStorage.setItem("Number", Util.encrypt(result.CustomerId));
				localStorage.setItem("User", Util.encrypt(email));
				navigate("/Email-Confirmation")
			}).catch((error) => {
				toast.error(error.message.replaceAll('"', ""));
			});
		}
	}


	const handleLogin = (e) => {
		e.preventDefault();
		if (LoginValidation(email, password)) {
			UserLogin(email, password).then((Result) => {
				
				// localStorage.setItem("User", Util.encrypt(email));
				// localStorage.setItem("PMToken", Util.encrypt(Result.CustomerToken));
				// localStorage.setItem("Number", Util.encrypt(Result.CustomerId));
				// localStorage.setItem("WishList", Util.encrypt(Result.WishlistId));
				// localStorage.setItem("Cart", Util.encrypt(Result.CartId));
				// localStorage.setItem(
				// 	"Subscribe",
				// 	Util.encrypt(Result.IsSubscribed)
				// );
				props.setSubscribe(Result.IsSubscribed);
				window.location.href = "/Account";
				Cookies.set('User', email, {
					expires: 5
				  });
				  Cookies.set('WishList', Result.WishlistId, {
					expires: 5
				  });
				  Cookies.set('Cart', Result.CartId, {
					expires: 5
				  });
				  Cookies.set('Subscribe', Result.IsSubscribed, {
					expires: 5
				  });
				  Cookies.set('Number', Result.CustomerId, {
					expires: 5
				  });
				  Cookies.set('CustomerToken', Result.Token, {
					expires: 5
				  });
			})
				.catch((error) => {
					if (
						error.message.replaceAll('"', "") === "Please Confirm Your Email"

					) {
						localStorage.setItem("User", Util.encrypt(email));

						navigate("/Email-Confirmation")
					} else if (error.message.replaceAll('"', "") === "Please Reset Your Password") {
						navigate("/Reset-Password")
					}

					toast.error(error.message.replaceAll('"', ""));
				});
		}

	}
	return (
		<>
			<div className="breadcrumb-area mb-50">
				<div className="container">
					<div className="row">
						<div className="col">
							<div className="breadcrumb-container HomeShop">
								<ul>
									<li><a href="index.html"><i className="fa fa-home"></i> Home</a></li>
									<li className="active">Login - Register</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>



			<div className="page-content mb-50">
				<div className="container">
					<div className="row" style={{ marginBottom: '50px' }}>
						<div className="col-sm-12 col-md-12 col-xs-12 col-lg-6 mb-30">
							<form onSubmit={handleLogin}>

								<div className="login-form">
									<h4 className="login-title">Login</h4>

									<div className="row">
										<div className="col-md-12 col-12 mb-2">
											<label>Email Address</label>
											<input className="mb-0" type="email" placeholder="Email Address" required onChange={(e) => setEmail(e.target.value)} />
										</div>
										<div className="col-12 mb-2 mt-2">
											<label>Password</label>
											<input className="mb-0" type="password" placeholder="Password" required onChange={(e) => setPassword(e.target.value)} />
										</div>
										{/* <div className="col-md-8 mt-3">

									<div className="check-box d-inline-block ml-0 ml-md-2 mt-1">
										<input type="checkbox" id="remember_me" />
										<label htmlFor="remember_me">Remember me</label>
									</div>

								</div> */}

										<div className="col-md-4 mt-10 mb-2 text-start text-md-end">
											<a href="/Forget-Password"> Forgotten pasward?</a>
										</div>

										<div className="col-md-12 mt-3">
											<button type='submit' className="register-button mt-0">Login</button>
										</div>

									</div>
								</div>

							</form>
						</div>
						<div className="col-sm-12 col-md-12 col-xs-12 col-lg-6">
							<form onSubmit={handleRegister}>

								<div className="login-form">
									<h4 className="login-title">Register</h4>

									<div className="row">
										<div className="col-md-6 col-12 mb-2">
											<label>First Name</label>
											<input className="mb-0" type="text" placeholder="First Name" required onChange={(e) => setFirstName(e.target.value)} />
										</div>
										<div className="col-md-6 col-12 mb-2">
											<label>Last Name</label>
											<input className="mb-0" type="text" placeholder="Last Name" required onChange={(e) => setLastName(e.target.value)} />
										</div>
										<div className="col-md-12 mb-20 mt-2">
											<label>Email Address</label>
											<input className="mb-0" type="email" placeholder="Email" required onChange={(e) => setEmail(e.target.value)} />
										</div>
										<div className="col-md-6 mb-20 mt-2">
											<label>Phone Number</label>
											<input className="mb-0" type="text" placeholder="Phone Number" required onChange={(e) => setPhonenumber(e.target.value)} />
										</div>
										<div className="col-md-6 mb-20 mt-2">
											<label>Password</label>
											<input className="mb-0" type="password" placeholder="Password" required onChange={(e) => setPassword(e.target.value)} />
										</div>
										<div className="col-md-6 mb-20 mt-2">
											<label>Confirm Password</label>
											<input className="mb-0" type="password" placeholder="Confirm Password" required onChange={(e) => setConfirmPassword(e.target.value)} />
										</div>
										<div className="col-12 mt-3">
											<button type='submit' className="register-button mt-0 RemUnderline">Register</button>
										</div>
									</div>
								</div>

							</form>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Authentication